import { PluginKey } from "@tiptap/pm/state";

import type { NodeJson } from "@corca/data";

export type SelectionNodesJson = {
  nodes: NodeJson[];
};

export type PluginState = {
  parsedNodes: SelectionNodesJson[] | null;
};

export const copyPasteKey = new PluginKey<PluginState>("copyPaste");
